import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/word.png'
import _imports_1 from '@/assets/images/pdf.png'
import _imports_2 from '@/assets/images/ppt.png'
import _imports_3 from '@/assets/images/unknown.png'
import _imports_4 from '@/assets/images/right-ward.png'
import _imports_5 from '@/assets/images/empty.png'


const _withScopeId = n => (_pushScopeId("data-v-4aefc082"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: "bulletin-detail" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "addon-before" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, null, -1))
const _hoisted_5 = { class: "cerrent-site" }
const _hoisted_6 = {
  class: "site-margin-auto",
  style: {"color":"#606266","font-size":"14px"}
}
const _hoisted_7 = { style: {"color":"#bfbfbf"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#595959"} }, "公告", -1))
const _hoisted_9 = { class: "project-name" }
const _hoisted_10 = { class: "project-no" }
const _hoisted_11 = { class: "detail-tabs" }
const _hoisted_12 = { class: "site-margin-auto detail-content" }
const _hoisted_13 = { class: "time" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 0,
  class: "bulletin-files"
}
const _hoisted_17 = {
  key: 0,
  src: _imports_0
}
const _hoisted_18 = {
  key: 1,
  src: _imports_1
}
const _hoisted_19 = {
  key: 2,
  src: _imports_2
}
const _hoisted_20 = {
  key: 3,
  src: _imports_3
}
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_24 = { class: "join-content" }
const _hoisted_25 = { style: {"color":"#ff543a"} }
const _hoisted_26 = { style: {"color":"#ff543a"} }
const _hoisted_27 = { style: {"color":"#ff543a"} }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-left":"12px"},
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_30 = {
  key: 1,
  class: "empty-content"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "暂无数据", -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]

import {
  listRelationById,
  checkLogin,
  checkToBid,
  getProjectById,
} from "@/api/site-home/index";
import { DoubleLeftOutlined } from "@ant-design/icons-vue";
import { setDocumentTitle } from "@/utils/document-title-utils";
import { Modal } from "ant-design-vue";
import { useRouter } from "vue-router";
import { useRouteHopping } from "@/utils/use-route-to";
import { WaterMark } from "@/utils/water-mark";
import { useBaiduTongji } from "@/utils/use-baidutongji";

import { defineComponent, onMounted, shallowRef, unref, watch } from "vue";
import { errorInfoDis } from "@/utils/project-utils";

const __default__ = defineComponent({
  name: "BulletinDetail",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

useBaiduTongji("");
const { currentRoute } = useRouter();
const { params } = unref(currentRoute);
// 是否全部折叠
const isAllCollapse = shallowRef(true);
const detailForm = shallowRef<any[]>([]);
// 公告列表
const detailList = shallowRef<any[]>([]);
const queryDetail = async (sid: string) => {
  try {
    const res = await listRelationById({ sid });
    detailList.value = res?.map((item: any) => {
      return {
        ...item,
        attachments: item.attachments?.map((file: any) => {
          return {
            ...file,
            fileType: file.fileName?.split(".").pop(),
          };
        }),
      };
    });
    if (detailList.value?.length) {
      detailForm.value = detailList.value?.filter(
        (item: any) => item.category === tabIndex.value
      );
    }
    // else {
    //   detailForm.value = detailList.value?.filter((item: any) => {
    //     return ![1, 2, 3, 4, 5].includes(item.category);
    //   });
    // }
  } catch (error: any) {
    errorInfoDis(error.message || "查询详情失败");
  }
};
const projectDetail = shallowRef<any>({});
const queryProjectById = async (sid: string) => {
  try {
    const res = await getProjectById({ sid });
    projectDetail.value = res;
  } catch (error: any) {
    errorInfoDis(error.message || "查询项目详情失败");
  }
};

const toToBidder = async (info: any) => {
  try {
    if (!info.sectionSourceId) {
      return errorInfoDis("缺失标段ID");
    }
    const res = await checkLogin();
    if (!res) {
      Modal.destroyAll();
      Modal.info({
        title: "系统提示",
        content: "登录状态已过期，请退出重新登录！",
        okText: "重新登录",
        onOk: () => {
          const loginUrl = `${
            process.env.VUE_APP_DOMAIN
          }/sso-cross-api/router/relogin/yzczb?url=${encodeURIComponent(
            window.location.href
          )}`;
          location.replace(loginUrl);
        },
      });
      return false;
    }
    if (!info.sid) {
      errorInfoDis("缺失ID");
      return false;
    }
    const bidRes = await checkToBid({ sid: info.sid });
    if (!bidRes) {
      errorInfoDis("当前项目不可报名!");
      return false;
    }
    window.open(
      `${process.env.VUE_APP_DOMAIN}/portal-bidder/transfer-page?id=${info.sectionSourceId}`,
      "_blank"
    );
  } catch (error: any) {
    return errorInfoDis(error.message || "校验失败");
  }
};

// 公告类型
const tabIndex = shallowRef<number>(1);

const searchVal = shallowRef("");
const searchType = shallowRef(1);
const onSearch = () => {
  if (searchVal.value) {
    useRouteHopping("/site-search", {
      searchType: searchType.value,
      name: searchVal.value,
    });
  } else {
    useRouteHopping("/site-search", {
      searchType: searchType.value,
    });
  }
};

const getTabColor = (type: number) => {
  const list = detailList.value?.filter((item: any) => item.category === type);
  return {
    color: list && list.length > 0 ? "" : "#909097",
  };
};

watch(
  () => tabIndex.value,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      // getCurrentTabData(detailList.value[0].projectClassification);
      detailForm.value = detailList.value?.filter(
        (item: any) => item.category === tabIndex.value
      );

      setTimeout(() => {
        // 添加水印
        const watermark_txt =
          "优质采招标采购平台<br/><div>www.yzczcb.com</div>"; //水印内容
        WaterMark({
          watermarl_element: ".bulletin--content__detail",
          watermark_txt: watermark_txt,
        });
      }, 10);
    }
  }
);

// 格式化公告格式 去除白色背景
const formatContent = (content: string) => {
  // 去除背景颜色// 处理十六进制和RGB格式的白色背景
  content = content.replace(/background\s*:\s*white\s*;?/gi, "");
  content = content.replace(/background\s*:\s*#fff(fff)?\s*;?/gi, "");
  content = content.replace(
    /background\s*:\s*rgb\(\s*255\s*,\s*255\s*,\s*255\s*\)\s*;?/gi,
    ""
  );
  content = content.replace(
    /background\s*:\s*rgba\(\s*255\s*,\s*255\s*,\s*255\s*,\s*[01]?(\.\d+)?\s*\)\s*;?/gi,
    ""
  );
  // 清理多余的分号和空格
  content = content.replace(/;\s*;/g, ";").trim();
  content = content.replace(/;\s*$/g, "");
  return content;
};

onMounted(async () => {
  setDocumentTitle("公告详情");

  const { id } = params;
  if (!id) {
    return errorInfoDis("缺失公告ID");
  }
  // tabIndex.value = Number(sessionStorage.getItem("bultinCategory")) || 1;
  await queryProjectById(id as string);
  await queryDetail(id as string).finally(() => {
    detailList.value.forEach((item: any) => {
      const currentsid = id.slice(0, -7);
      if (item.sid === currentsid) {
        tabIndex.value = item.category;
      }
    });
    // 添加水印
    const watermark_txt = "优质采招标采购平台"; //水印内容
    WaterMark({
      watermarl_element: ".bulletin--content__detail",
      watermark_txt: watermark_txt,
    });
  });
});

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_search_outlined = _resolveComponent("search-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_input, {
        size: "large",
        value: _unref(searchVal),
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(searchVal) ? (searchVal).value = $event : null)),
        onKeyup: _withKeys(onSearch, ["enter"]),
        class: "search-input",
        placeholder: "请输入搜索项目名称、企业、产品名称"
      }, {
        addonBefore: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_select, {
              value: _unref(searchType),
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchType) ? (searchType).value = $event : null)),
              style: {"width":"110px"},
              size: "large"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode("项目")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: 2 }, {
                  default: _withCtx(() => [
                    _createTextVNode("发布单位")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            _hoisted_4
          ])
        ]),
        _: 1
      }, 8, ["value", "onKeyup"]),
      _createVNode(_component_a_button, {
        size: "large",
        type: "primary",
        class: "search-btn",
        onClick: onSearch
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_search_outlined)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" 搜索 ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, [
          _createTextVNode(" 首页 / " + _toDisplayString((_unref(detailList) &&
              _unref(detailList).length &&
              _unref(detailList)[0].projectClassificationName) ||
            "项目类型") + " / ", 1),
          _hoisted_8
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createTextVNode(_toDisplayString(_unref(projectDetail).projectName) + " ", 1),
      _createElementVNode("div", _hoisted_10, "项目编号：" + _toDisplayString(_unref(projectDetail).projectNo), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_unref(projectDetail).projectClassification === 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (tabIndex.value = 1)),
              class: _normalizeClass({ active: _unref(tabIndex) === 1 }),
              style: _normalizeStyle(getTabColor(1))
            }, " 招标计划 ", 6),
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (tabIndex.value = 2)),
              class: _normalizeClass({ active: _unref(tabIndex) === 2 }),
              style: _normalizeStyle(getTabColor(2))
            }, " 招标公告 ", 6),
            _createElementVNode("div", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (tabIndex.value = 3)),
              class: _normalizeClass({ active: _unref(tabIndex) === 3 }),
              style: _normalizeStyle(getTabColor(3))
            }, " 澄清公告 ", 6),
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (tabIndex.value = 4)),
              class: _normalizeClass({ active: _unref(tabIndex) === 4 }),
              style: _normalizeStyle(getTabColor(4))
            }, " 中标候选人公示 ", 6),
            _createElementVNode("div", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (tabIndex.value = 5)),
              class: _normalizeClass({ active: _unref(tabIndex) === 5 }),
              style: _normalizeStyle(getTabColor(5))
            }, " 中标结果公告 ", 6)
          ], 64))
        : (_unref(projectDetail).projectClassification === 2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (tabIndex.value = 11)),
                class: _normalizeClass({ active: _unref(tabIndex) === 11 }),
                style: _normalizeStyle(getTabColor(11))
              }, " 需求调查 ", 6),
              _createElementVNode("div", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (tabIndex.value = 2)),
                class: _normalizeClass({ active: _unref(tabIndex) === 2 }),
                style: _normalizeStyle(getTabColor(2))
              }, " 采购公告 ", 6),
              _createElementVNode("div", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (tabIndex.value = 3)),
                class: _normalizeClass({ active: _unref(tabIndex) === 3 }),
                style: _normalizeStyle(getTabColor(3))
              }, " 澄清公告 ", 6),
              _createElementVNode("div", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (tabIndex.value = 5)),
                class: _normalizeClass({ active: _unref(tabIndex) === 5 }),
                style: _normalizeStyle(getTabColor(5))
              }, " 结果公告 ", 6),
              _createElementVNode("div", {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (tabIndex.value = 9)),
                class: _normalizeClass({ active: _unref(tabIndex) === 9 }),
                style: _normalizeStyle(getTabColor(9))
              }, " 其他公告 ", 6)
            ], 64))
          : (_unref(projectDetail).projectClassification === 3)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (tabIndex.value = 2)),
                  class: _normalizeClass({ active: _unref(tabIndex) === 2 }),
                  style: _normalizeStyle(getTabColor(2))
                }, " 采购公告 ", 6),
                _createElementVNode("div", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (tabIndex.value = 3)),
                  class: _normalizeClass({ active: _unref(tabIndex) === 3 }),
                  style: _normalizeStyle(getTabColor(3))
                }, " 澄清公告 ", 6),
                _createElementVNode("div", {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (tabIndex.value = 5)),
                  class: _normalizeClass({ active: _unref(tabIndex) === 5 }),
                  style: _normalizeStyle(getTabColor(5))
                }, " 结果公示 ", 6),
                _createElementVNode("div", {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (tabIndex.value = 9)),
                  class: _normalizeClass({ active: _unref(tabIndex) === 9 }),
                  style: _normalizeStyle(getTabColor(9))
                }, " 其他公告 ", 6)
              ], 64))
            : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_unref(detailForm) && _unref(detailForm).length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_a_row, {
              type: "flex",
              justify: "end",
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (isAllCollapse.value = !_unref(isAllCollapse)))
                }, [
                  _createVNode(_unref(DoubleLeftOutlined), {
                    style: _normalizeStyle(`transform: rotate(${_unref(isAllCollapse) ? 90 : -90}deg)`)
                  }, null, 8, ["style"]),
                  _createTextVNode(" " + _toDisplayString(_unref(isAllCollapse) ? "折叠" : "展开") + "全部 ", 1)
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detailForm), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "detail-item",
                key: item.id
              }, [
                _createElementVNode("div", _hoisted_13, "发布时间：" + _toDisplayString(item.releaseTime), 1),
                _withDirectives(_createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, _toDisplayString(item.title), 1)
                ], 512), [
                  [_vShow, item.legalStatus === 2]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: "bulletin--content__detail bulletin--content",
                    innerHTML: formatContent(item.contentText)
                  }, null, 8, _hoisted_15),
                  (item.attachments?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_a_form, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "附件" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.attachments, (file) => {
                                  return (_openBlock(), _createBlock(_component_a_row, {
                                    type: "flex",
                                    align: "middle",
                                    key: file.id
                                  }, {
                                    default: _withCtx(() => [
                                      (['doc', 'docx'].includes(file.fileType))
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                                        : (file.fileType === 'pdf')
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                                          : (file.fileType === 'ppt')
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                                            : (_openBlock(), _createElementBlock("img", _hoisted_20)),
                                      _createElementVNode("a", {
                                        href: file.sourceUrl,
                                        class: "download-btn",
                                        download: ""
                                      }, _toDisplayString(file.viewName), 9, _hoisted_21)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, _unref(isAllCollapse)]
                ]),
                _hoisted_22,
                _hoisted_23,
                (item.canJoin === 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "fixed-right",
                      style: _normalizeStyle(`${_unref(isAllCollapse) ? '' : 'top: 12px'}`)
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", null, [
                          _createTextVNode(" 剩余时间："),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(item["durations"]["days"]), 1),
                          _createTextVNode(" 天 "),
                          _createElementVNode("span", _hoisted_26, _toDisplayString(item["durations"]["hours"]), 1),
                          _createTextVNode(" 时 "),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(item["durations"]["minutes"]), 1),
                          _createTextVNode(" 分 ")
                        ]),
                        (item.tendWay !== 2 && item.tendWay !== 6)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              onClick: () => toToBidder(item),
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("立即投标 "),
                                _hoisted_28
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_a_row, {
                        type: "flex",
                        justify: "end"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_29
                        ]),
                        _: 1
                      })
                    ], 4))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_33))
    ])
  ]))
}
}

})